import { ICONES_FACETA } from '@/global/components/EscopoFuncionario/Cascata'
import { FormFieldAutocomplete } from 'global/components/Form'
import { local as locais } from 'service/api'
import { useStore } from 'store'
import { type CondicaoUi, contar } from './condicao-ui'

function ParametrosLocal() {
    const empresaId = useStore(state => state.companyId)
    const { data = [] } = locais.useFetch({ queryParams: { empresaId } })
    const nomePorId = new Map(data.map(it => [it.id, it.nomeLocal]))

    return (
        <FormFieldAutocomplete
            name="parametros.localIds"
            label="Locais"
            multiple
            required
            options={data.map(it => it.id)}
            getOptionLabel={(id: number) => nomePorId.get(id) ?? ''}
            getOptionKey={(id: number) => String(id)}
            isOptionEqualToValue={(opcao, valor) => opcao === valor}
        />
    )
}

export const local: CondicaoUi = {
    icone: ICONES_FACETA.locais,
    parametrosIniciais: { localIds: [] },
    Parametros: ParametrosLocal,
    resumir: parametros => contar(parametros.localIds, 'local', 'locais'),
}
